<template>
	<section class="browse">
		<div class="browse__inner _cnt">
			<div class="browse__title _h1">{{ $t('Browse by Category') }}</div>
			<div class="browse__line _line"><span class="_h2"></span></div>
			<div class="browse__items">
				<router-link class="browse__item" to="/products/all?types=knife">
					<span class="_h2">{{ $t('Knife') }}</span>
					<div class="browse__item-bg _ibg">
						<img src="@/assets/img/bg/browse/01.png" />
					</div>
				</router-link>
				<router-link class="browse__item" to="/products/all?types=rifle">
					<span class="_h2">{{ $t('Rifle') }}</span>
					<div class="browse__item-bg _ibg">
						<img src="@/assets/img/bg/browse/02.png" />
					</div>
				</router-link>
				<router-link
					class="browse__item"
					to="/products/all?types=pistol"
				>
					<span class="_h2">{{ $t('Pistol') }}</span>
					<div class="browse__item-bg _ibg">
						<img src="@/assets/img/bg/browse/03.png" />
					</div>
				</router-link>
				<router-link
					class="browse__item"
					to="/products/all?types=smg"
				>
					<span class="_h2">{{ $t('Smg') }}</span>
					<div class="browse__item-bg _ibg">
						<img src="@/assets/img/bg/browse/04.png" />
					</div>
				</router-link>
				<router-link
					class="browse__item"
					to="/products/all?types=sniper+rifle"
				>
					<span class="_h2">{{ $t('Sniper Rifle') }}</span>
					<div class="browse__item-bg _ibg">
						<img src="@/assets/img/bg/browse/05.png" />
					</div>
				</router-link>
				<router-link
					class="browse__item"
					to="/products/all?types=shotgun"
				>
					<span class="_h2">{{ $t('Shotgun') }}</span>
					<div class="browse__item-bg _ibg">
						<img src="@/assets/img/bg/browse/06.png" />
					</div>
				</router-link>
				<router-link
					class="browse__item"
					to="/products/all?types=machinegun"
					><span class="_h2">{{ $t('Machinegun') }}</span>
					<div class="browse__item-bg _ibg">
						<img src="@/assets/img/bg/browse/07.png" />
					</div>
				</router-link>
			</div>
		</div>
	</section>
</template>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/fonts' as *;
@use '@/assets/styles/components/classes' as *;

//========================================================================================================================================================

.browse {
	@include adaptiveValue('padding-top', 75, 20);
	@include adaptiveValue('padding-bottom', 75, 20);
	&__inner {
	}
	&__title {
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}
	&__line {
		max-width: 710px;
		margin-left: auto;
		margin-right: auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 20);
		}
	}
	&__items {
		display: flex;
		@include adaptiveValue('gap', 16, 6, 1470, 992, 1);
		@media (max-width: $md2) {
			flex-wrap: wrap;
		}
	}
	&__item {
		position: relative;
		background-color: var(--bg-third-color);
		border-radius: var(--border-radius-primary);
		overflow: hidden;
		padding: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		@media (any-hover: hover) and (min-width: $md2) {
			&:hover {
				flex: 0 0 29%;
				span {
					transform: rotate(0deg);
				}
				.browse__item-bg {
					opacity: 1;
				}
			}
		}
		@media (min-width: $md2) {
			flex: 0 1 14.3%;
			transition: flex 0.3s ease 0s;
			@include adaptiveValue('min-height', 417, 276, 1470, 992, 1);
		}
		@media (max-width: $md2) {
			flex: 0 1 calc(33.333% - 4px);
			padding-top: 13.5%;
			padding-bottom: 13.5%;
			&:last-child {
				flex: 1 1 100%;
			}
		}
		@media (max-width: $md3) {
			flex: 0 1 calc(50% - 3px);
			padding-top: 22.5%;
			padding-bottom: 22.5%;
		}
		@media (max-width: $md4) {
			flex: 1 1 100%;
		}
		span {
			position: relative;
			z-index: var(--secondary-z-index);
			@media (min-width: $md2) {
				transform: rotate(-90deg);
				transition: transform 0.3s ease 0s;
			}
		}
		&-bg {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			&::before {
				content: '';
				z-index: var(--base-z-index);
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				background-color: var(--bg-secondary-color);
			}
			@media (min-width: $md2) {
				transition: opacity 0.3s ease 0s;
				opacity: 0;
			}
		}
	}
}
</style>
